import moment from 'moment-timezone';

import {type State} from './types';

export const DEFAULT_STATE: State = {
    dateRange: {fromInclusive: moment(), toExclusive: null},
    continuePlan: false,
    validationErrors: [],
};
